module.exports = __webpack_public_path__ + "7e9c4caba71cd67c47b615891f2312f3.svg";